import { useState, useEffect, useContext } from 'react'
import { FiHome, FiPlus, FiSearch, FiEdit2 } from 'react-icons/fi'
import { Link } from 'react-router-dom'
import { getDocs, collection } from 'firebase/firestore'

import { Header } from '../../components/Header'
import { Title } from '../../components/Title'
import { AuthContext } from '../../contexts/auth'
import { db } from '../../services/firebaseConnection'

import { Content } from './styles'

export function Dashboard() {
  //const { questions, setQuestions } = useContext(AuthContext)

  const [allQuestions, setAllQuestions] = useState('')

  useEffect(() => {
    async function loadTotalQuestions() {
      const totalQuestions = collection(db, "questions")

      await getDocs(totalQuestions)
        .then((snapshot) => {
          //console.log(snapshot.size)
          setAllQuestions(snapshot.size)
        })
        .catch((err) => {
          console.log(err)
        })
    }

    loadTotalQuestions()
  }, [])

  return (
    <>
      <Header />
      <Content>
        <Title name="Início">
          <FiHome size={25} />
        </Title>

        <div className='container'>
          <div className='boxes-summary'>
            <div className='box-summary'>
              <h3>Total de Questões: </h3>
              <strong>{allQuestions} Questões</strong>
            </div>


          </div>
        </div>


      </Content>
    </>
  )
}